import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars

export default {
  methods: {
    editableControlChange(payload) {
      this[payload.subSelectName].set(payload.id, payload.controlAux)
    },
    checkDisable(value, editableControlsMap) {
      var vm = this;
      if (!vm.isTemplate()) {
        if (
          editableControlsMap.get(value) &&
          editableControlsMap.get(value).userCategory.code == 4
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false
      }
    },
    validationComponents(control) {
      var vm = this;
      if (!vm.isTemplate()) {
        if (control == undefined || (control && control.userCategory.code != 4)) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    }
  },
};
